module.exports = __webpack_public_path__ + "8b5c4fef831a8deadf258cfe51776c4d.svg";